import React from 'react';
import { Styles } from './styles';
import { Text } from 'atoms/Text/Text';
import { AlgoliaProduct } from 'models/products';
import { defaultTheme } from 'constants/theme/defaultTheme';
import { Pills } from 'atoms/Pills/Pills';
import { Spacer } from 'components/Spacer/Spacer';

export type ProductDetailCardProps = {
  hit: AlgoliaProduct;
};

export const ProductDetailCard: React.FC<ProductDetailCardProps> = ({ hit }) => {
  return (
    <Styles.Wrapper>
      <Text.body1>Product details</Text.body1>
      <Styles.Content>
        {hit.sku && (
          <Styles.Row>
            <Text.button2 color={defaultTheme.colors.deepGrey} width="170px">
              SKU
            </Text.button2>
            <Text.button2 color={defaultTheme.colors.deepGrey}>{hit.sku.join(', ')}</Text.button2>
          </Styles.Row>
        )}
        {hit.unitOfMeasurement && (
          <Styles.Row>
            <Text.button2 color={defaultTheme.colors.deepGrey} width="170px">
              Unit of measuments
            </Text.button2>
            <Text.button2 color={defaultTheme.colors.deepGrey}>
              {hit.unitOfMeasurement.join(', ')}
            </Text.button2>
          </Styles.Row>
        )}
        {hit.orderUnits && (
          <Styles.Row>
            <Text.button2 color={defaultTheme.colors.deepGrey} width="170px">
              Order units
            </Text.button2>
            <Text.button2 color={defaultTheme.colors.deepGrey}>{hit.orderUnits}</Text.button2>
          </Styles.Row>
        )}
        {hit.productShape && (
          <Styles.Row>
            <Text.button2 color={defaultTheme.colors.deepGrey} width="170px">
              Product shape
            </Text.button2>
            <Text.button2 color={defaultTheme.colors.deepGrey}>
              {hit.productShape.join(', ')}
            </Text.button2>
          </Styles.Row>
        )}
        {hit.hcpcs && (
          <Styles.Row column={hit.hcpcs.length > 1}>
            <Text.button2 color={defaultTheme.colors.deepGrey} width="170px">
              HCPCS codes
            </Text.button2>
            {hit.hcpcs.length > 1 && <Spacer.Column numberOfSpaces={3} />}
            <Pills items={hit.hcpcs} />
          </Styles.Row>
        )}
        <Styles.Row column={hit.categories.length > 1}>
          <Text.button2 color={defaultTheme.colors.deepGrey} width="170px">
            Categories
          </Text.button2>
          {hit.categories.length > 1 && <Spacer.Column numberOfSpaces={3} />}
          <Pills items={hit.categories} />
        </Styles.Row>
      </Styles.Content>
    </Styles.Wrapper>
  );
};
